import actionCreatorFactory from 'typescript-fsa';
import {SettingsDataPayload} from './State';

const actionCreator = actionCreatorFactory('SETTINGS');
export const initializeSettingsAction = actionCreator<void>('INITIALIZE');
export const settingsDataLoadedAction = actionCreator<SettingsDataPayload>('DATA_LOADED');
export const settingsDataFailedAction = actionCreator<void>('DATA_LOADING_FAILED');
